import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {sizing} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingSmall} from "@khanacademy/wonder-blocks-typography";
import {staticUrl} from "@khan/urls";

interface Props {
    errorType: "noResult" | "noFavorites";
}

export const ToolCardsEmptyState: React.FC<Props> = ({errorType}) => {
    const strings = {
        noResult: {
            title: t`No tools available`,
            text: t`There are no tools available for this category.`,
            url: "/images/coach-dashboard/khanmigo-investigate.png",
            width: 100,
            alt: t`No tools available illustration`,
        },
        noFavorites: {
            title: t`Save your favorite tools!`,
            text: t`You can mark your favorites by clicking on the star in the top right of each tool card.`,
            url: "/images/coach-dashboard/favorite-empty-state.png",
            width: 200,
            alt: t`No favorites illustration`,
        },
    };

    const {title, text, url, width, alt} = strings[errorType];

    return (
        <View style={styles.noResults}>
            <img src={staticUrl(url)} alt={alt} width={`${width}px`} />
            <HeadingSmall style={styles.noResultsHeading}>{title}</HeadingSmall>
            <Body style={styles.noResultsBody}>{text}</Body>
        </View>
    );
};

const styles = StyleSheet.create({
    noResults: {
        marginBlockStart: sizing.size_360,
        alignItems: "center",
        padding: sizing.size_360,
    },
    noResultsHeading: {
        marginBlockStart: sizing.size_120,
    },
    noResultsBody: {
        marginBlockStart: sizing.size_080,
        width: 320,
        textAlign: "center",
        lineHeight: "22px",
    },
});
